export default __webpack_public_path__ + "static/media/regulatory--no-right-turn--g2.97edc91d.png";